import { PdfDocumentAction } from "./pdfDocumentActionStorage";

export const triggerPdfDownload = (blobData: BlobPart, filename: string) => {
  const pdfBlob = new Blob([blobData], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Best-effort print: open PDF in a new tab and call print().
 * If automatic printing is unavailable or blocked, leave the PDF open for manual print.
 */
export const triggerPdfPrint = (blobData: BlobPart, _filename?: string) => {
  const pdfBlob = new Blob([blobData], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);
  let printWindow: Window | null = null;

  try {
    printWindow = window.open(url, "_blank");
  } catch {
    printWindow = null;
  }

  if (!printWindow) {
    // Popup blocked — try opening via anchor (still a new tab when allowed).
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
    return;
  }

  let printed = false;
  const tryPrint = () => {
    if (printed) return;
    printed = true;
    try {
      printWindow.focus();
      printWindow.print();
    } catch {
      // Leave tab open for manual print
    }
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
  };

  try {
    printWindow.addEventListener("load", () => {
      window.setTimeout(tryPrint, 250);
    });
  } catch {
    // cross-origin / inaccessible document — still attempt print
  }

  window.setTimeout(tryPrint, 1500);
};

export const deliverPdf = (
  blobData: BlobPart,
  filename: string,
  action: PdfDocumentAction
) => {
  if (action === "print") {
    triggerPdfPrint(blobData, filename);
  } else {
    triggerPdfDownload(blobData, filename);
  }
};

export const getPdfDownloadErrorMessage = (error: unknown, fallback: string): string => {
  return (
    (error as any)?.getError?.() ??
    (error as any)?.response?.data?.detail ??
    (error as any)?.data?.detail ??
    fallback
  );
};
